import { Common } from '../common';
import {
  LinkCreateValues,
  LinkUpdateValues,
  MessageRequestLink,
} from '../models/previsit/messageRequest';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: LinkCreateValues): Promise<MessageRequestLink> {
    const url = this.common.constructPath(`/previsit/message-request-links`);
    return this.common.postJSON(url, values);
  }

  async findOneById(linkId: string): Promise<MessageRequestLink> {
    const url = this.common.constructPath(
      `/previsit/message-request-links/${linkId}`,
    );
    return this.common.getJSON(url);
  }

  async findAll(): Promise<MessageRequestLink[]> {
    const url = this.common.constructPath(`/previsit/message-request-links`);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async update(
    linkId: string,
    values: LinkUpdateValues,
  ): Promise<MessageRequestLink> {
    const url = this.common.constructPath(
      `/previsit/message-request-links/${linkId}`,
    );
    return this.common.patchJSON(url, values);
  }

  async remove(linkId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `/previsit/message-request-links/${linkId}`,
    );
    return this.common.deleteJSON(url);
  }
}
